<div class="banner">
  <h1>Notification Management</h1>
</div>
<fgb-account-nav></fgb-account-nav>
